// The ARTICLE TRACE waveform, derived from a block recipe. Prose reads low, code
// spikes, terminal clusters tight, embeds are solid marked blocks. Deterministic
// (an instrument doesn't roll dice): the same recipe always draws the same bars.
//
// In production the canonical trace is rendered SERVER-SIDE from block metadata
// (Readout::ArticleInstrumentation, PR5) and inlined as static SVG — crawlable,
// no-JS safe. These exports draw the cheap client-side fallback forms only, and
// are shared with the transport controller. The wob/AMPS/BLOCKS math here is
// byte-identical to the server generator, so client fallbacks match the goldens.

export const wob = (i) => {
  const x = Math.sin(i * 12.9898) * 43758.5453
  return x - Math.floor(x)
}

export const AMPS = {
  prose: (i) => 0.10 + 0.10 * wob(i),
  code: (i) => 0.58 + 0.34 * wob(i),
  diffish: (i) => 0.44 + 0.22 * wob(i),
  diff: (i) => 0.44 + 0.22 * wob(i),
  term: (i) => 0.30 + 0.16 * wob(i * 3 + 7),
  cta: (i) => 0.22 + 0.08 * wob(i),
  receipts: (i) => 0.16 + 0.06 * wob(i),
  marker: () => 1,
}

// Solid-block types: a single rounded rect, not a bar cluster.
export const BLOCKS = { video: 0.55, play: 0.62, fig: 0.38 }

const NS = "http://www.w3.org/2000/svg"

// Draw a trace into `svg`. segs: [{type, w}]; W/H: viewBox units; bw/gap: bar
// width/gap; minAmp: legend chips only (schematic scale, 0 for real traces).
export function drawTrace(svg, segs, W, H, bw, gap, minAmp = 0) {
  svg.textContent = ""
  const total = segs.reduce((a, s) => a + s.w, 0) || 1
  let x = 0
  let gi = 0
  for (const s of segs) {
    const segW = (s.w / total) * W
    if (s.type === "marker") {
      const r = document.createElementNS(NS, "rect")
      r.setAttribute("x", (x + segW / 2 - 0.75).toFixed(2))
      r.setAttribute("y", 0)
      r.setAttribute("width", 1.5)
      r.setAttribute("height", H)
      r.setAttribute("class", "bar b-marker")
      svg.appendChild(r)
      x += segW
      continue
    }
    if (s.type in BLOCKS) {
      const h = H * BLOCKS[s.type]
      const r = document.createElementNS(NS, "rect")
      r.setAttribute("x", (x + gap).toFixed(2))
      r.setAttribute("y", ((H - h) / 2).toFixed(2))
      r.setAttribute("width", Math.max(bw, segW - gap * 2).toFixed(2))
      r.setAttribute("height", h.toFixed(2))
      r.setAttribute("rx", 1)
      r.setAttribute("class", "bar b-" + s.type)
      svg.appendChild(r)
      x += segW
      continue
    }
    const amp = AMPS[s.type] || AMPS.prose
    const step = s.type === "term" ? bw + gap * 0.5 : bw + gap
    const n = Math.max(1, Math.floor(segW / step))
    for (let k = 0; k < n; k++) {
      const h = Math.max(1.5, H * Math.max(minAmp, amp(gi++)))
      const r = document.createElementNS(NS, "rect")
      r.setAttribute("x", (x + k * step).toFixed(2))
      r.setAttribute("y", ((H - h) / 2).toFixed(2))
      r.setAttribute("width", bw)
      r.setAttribute("height", h.toFixed(2))
      r.setAttribute("class", "bar b-" + s.type)
      svg.appendChild(r)
    }
    x += segW
  }
}
